import { ReactNode } from "react";
import MobileTabHeading from "./MobileTabHeading";
import BoardTaskIcon from "@svg/new-design/exam";

const MobileSkillsPanel = ({ parsedContent }: { parsedContent: ReactNode }) => {
  return (
    <div className="py-6" id="skills">
      <MobileTabHeading icon={BoardTaskIcon} title="مهارت ها" />
      <div className="pt-4 body-sm text-fds-secondary">{parsedContent}</div>
    </div>
  );
};

export default MobileSkillsPanel;
